import { render, staticRenderFns } from "./tabs-controller.vue?vue&type=template&id=dd94e25c&scoped=true"
import script from "./tabs-controller.vue?vue&type=script&lang=ts&setup=true"
export * from "./tabs-controller.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./tabs-controller.vue?vue&type=style&index=0&id=dd94e25c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd94e25c",
  null
  
)

export default component.exports